import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService, TdDialogService } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { ExploracionService, MasterService, LoginService } from '../../../../../services/';

import { Exploracion } from '../../../../../models';

@Component({
  selector: 'qs-exploraciondetalle',
  styleUrls: ['./exploraciondetalle.component.scss'],
  templateUrl: './exploraciondetalle.component.html',
  viewProviders: [ExploracionService, MasterService, ],
})

export class ExploracionDetalleComponent implements AfterViewInit, OnDestroy {

  private mode: string;
  private title: string;

  private idPaciente: string;
  private visita: string;
  private cip: string;
  private colegiado: string;
  private accion: string;

  private exploracion: Exploracion;
  private oldExploracion: Exploracion;

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _master: MasterService,
    private _exploracionService: ExploracionService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.colegiado = this._loginService.colegiado;
    this.cip = this._loginService.consulta.cip;
    this.visita = this._loginService.consulta.visita;
    this.exploracion = new Exploracion();
    this.oldExploracion = new Exploracion();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.exploracion = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
    }
  }

  ngAfterViewInit(): void {
    this._changeDetectorRef.detectChanges();
  }

  delete(form: NgForm): void {
    this.mode = 'del';
    this.save(form);
  }

  save(form: NgForm): void {
    let fecha: Date = new Date();
    let message: string = '';
    let error: string = '';
    let messages: string[] = [
      'Exploracion Añadida correctamente.', 'Error añadiendo Exploracion.',
      'Exploracion Actualizada correctamente.', 'Error actualizando Exploracion.',
      'Exploracion Borrada correctamente.', 'Error borrando Exploracion', ];
    let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
    switch (this.mode) {
      case 'edit':
        this.accion = 'M';
        message = messages[2];
        error = message[3];
        break;
      case 'add':
        this.accion = 'I';
        message = messages[0];
        error = messages[1];
        break;
      case 'del':
        this.accion = 'B';
        message = messages[4];
        error = messages[5];
        break;
      default: break;
    }

    if (form.valid) {
      this._loadingService.register();
      let params: any = {
        iIdExploracion: this.accion !== 'I' ? this.exploracion.idExplotex : '',
        iNumExpediente: this.idPaciente,
        iFecha: fecha,
        iNumVisita: this.visita,
        iDniMed: this._loginService.profesional.Dni,
        iLinea: 0,
        iCip: this.cip,
        iTexto: this.exploracion.texto,
        iHora: hora,
        iAccion: this.accion,
      };
      this._exploracionService.guardarExploracion(params).subscribe((res: any) => {
        if (res) {
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
          this._router.navigate(['/main/consulta/' + this.idPaciente + '/hojadeseguimiento', { outlets: { hojadeseguimiento: ['exploracion'] } }]);
        } else {
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
        }
      }, (resError: Error) => {
        this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
        this._loadingService.resolve();
      });
    }
  }

  /*
  canDeactivate(): Promise<boolean> | boolean {
    if ((this.oldExploracion.principioActivo == this.exploracion.principioActivo) &&
      (this.oldExploracion.fecha.getDate() == this.exploracion.fecha.getDate()) &&
      (this.oldExploracion.estado == this.exploracion.estado) &&
      (this.oldExploracion.tipo == this.exploracion.tipo)) {
      return true;
    } else {
      if (this.mode != 'save') {
        return new Promise((resolve) => {
          this._dialogService.openConfirm({
            message: 'Si pulsa aceptar, se perderán los datos introducidos.',
            title: '¿Desea abandonar el alta de exploracion?',
            acceptButton: 'Aceptar',
            cancelButton: 'Cancelar'
          }).afterClosed().subscribe((accept: boolean) => {
            if (accept) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      } else {
        return true;
      }
    }
  }*/

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/exploracion/exploraciondetalle/exploraciondetalle.component.ts